import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

/**
 * Saqlanmagan o'zgarish bilan chiqishda ogohlantirish (TZ 7.2 §8).
 *
 * Ikki yo'l bilan chiqib ketish mumkin va ikkalasi ham yopilishi kerak:
 *   1. ilova ichida havola bosish — `useBlocker` (React Router);
 *   2. brauzer oynasini yopish yoki manzil kiritish — `beforeunload`.
 *
 * `beforeunload` da o'z matnimizni ko'rsatib bo'lmaydi — brauzer o'zining
 * standart xabarini chiqaradi. Shuning uchun ilova ichidagi ogohlantirish
 * alohida yozilgan: u nima saqlanmaganini aytadi.
 */
export function useUnsavedGuard(isDirty: boolean): {
  blocked: boolean;
  proceed: () => void;
  cancel: () => void;
} {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (!isDirty) return false;
    return currentLocation.pathname !== nextLocation.pathname;
  });

  useEffect(() => {
    if (!isDirty) return;

    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Eski brauzerlar uchun — qiymatning o'zi ko'rsatilmaydi
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);

  return {
    blocked: blocker.state === 'blocked',
    proceed: () => blocker.proceed?.(),
    cancel: () => blocker.reset?.(),
  };
}
